export default {
  label: {
    base: {
      backgroundColor: 'white',
      borderColor: 'grey-20',
      color: 'grey-80',
      svg: {},
      hover: {
        backgroundColor: 'grey-05',
        svg: {}
      },
      focus: {
        outline: '2px solid orange',
        borderColor: 'black',
        backgroundColor: 'grey-05'
      }
    },
    variants: {
      checked: {
        borderColor: 'black',
        boxShadow: 'radioChecked',
        backgroundColor: 'white',
        svg: {
          color: 'grey-100'
        }
      },
      disabled: {
        cursor: 'initial',
        svg: {}
      }
    }
  }
};